"use client";

import cx from "classnames";

import LanguageSelector from "@/components/LanguageSelector";
import CurrencySelector from "@/components/CurrencySelector";
import SizeUnitSelector from "@/components/SizeUnitSelector";

import useUxStore from "@/stores/ux";

const MetaBar = ({
  showUnitSizeSelector = true,
  showCurrencySelector = true,
  showLanguageSelector = true,
  languageSpecificPaths = undefined,
  wide = false,
}) => {
  const showMetaBar = useUxStore((state) => state.showMetaBar);

  if (!showMetaBar) {
    return null;
  }

  return (
    <div className="bg-neutral-200 h-10 px-4 flex flex-1 gap-1 md:gap-2 items-center justify-end relative z-99999">
      <div
        className={cx("h-full mx-auto flex flex-1 gap-1 md:gap-2 items-center justify-end", {
          "max-w-root": !wide,
          "max-w-root-wide": wide,
        })}
      >
        {showUnitSizeSelector && (
          <div className="text-xs md:text-sm">
            <SizeUnitSelector />
          </div>
        )}
        {showCurrencySelector && (
          <div className="text-xs md:text-sm">
            <CurrencySelector />
          </div>
        )}
        {showLanguageSelector && (
          <div className="text-xs md:text-sm">
            <LanguageSelector languageSpecificPaths={languageSpecificPaths} />
          </div>
        )}
      </div>
    </div>
  );
};

export default MetaBar;
